import { settings } from "../../app/settings";

const ACCESS_TOKEN = settings.accessTokenString ?? "auth";
const REFRESH_TOKEN = settings.refreshTokenString ?? "refresh";
const PERMISSIONS = settings.permissions ?? "permissions";

export const accessResponseString = settings.accessResponseString ?? "access_id";
export const refreshResponseString = settings.refreshResponseString ?? "refresh_id";
export const refreshSessionString = settings.refreshSessionString ?? "refresh_session_id";

export const userProfileString = settings.userProfileString ?? "userData";
export const userNameString = settings.userNameString ?? "email";
export const passwordString = settings.passwordString ?? "password";
export const recaptchaString = settings.recaptchaString ?? "recaptcha";

export const passwordChangeRequiredString = settings.passwordChangeRequiredString ?? "IsPasswordChangeRequired";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);

export const getPermissions = () => JSON.parse(localStorage.getItem(PERMISSIONS));

export const getUser = () =>
  localStorage.getItem(userProfileString) ? JSON.parse(localStorage.getItem(userProfileString)) : null;

export const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN);

export const removeUser = () => localStorage.removeItem(userProfileString);

export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
};

export const removeTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(PERMISSIONS);
};

export const setPermissions = permissions => localStorage.setItem(PERMISSIONS, permissions);
